import React, {useEffect, useState} from 'react';
import './App.css';
import TopMenu from "./components/TopMenu";
import RightColumn from "./components/RightColumn";
import CenterPlot from "./components/CenterPlot";
import LeftColumn from "./components/LeftColumn";
import LoginPage from "./components/LoginPage";

import {BASE_URL} from "./router/apiClient";
import axiosClient from "./router/apiClient";

interface DataPoint {
    x: number;
    y: number;
    source: string;
    filename: string;
    imageUrl: string;
}

const App: React.FC = () => {
    const [selectedImage, setSelectedImage] = useState<DataPoint | null>(null);
    const [data, setData] = useState<DataPoint[]>([]);
    const [apnData, setApnData] = useState<DataPoint[]>([]);
    const [selectedOptions, setSelectedOptions] = useState<string[]>(Array(5).fill(""));
    const [filterImage, setFilterImage] = useState<string>("");
    const [fetchError, setFetchError] = useState<boolean>(false);
    const [hideAPNs, setHideAPNs] = useState(false);
    const [authorized, setAuthorized] = useState(false);

    const handleDatasetChange = () => {
        setSelectedImage(null);
    };

    const fetchData = async (options: string[]) => {
        try {
            const queryParams = new URLSearchParams({
                dataset: options[0],
                datasetPart: options[1],
                model: options[2],
                modelLayer: options[3],
                projection: options[4]
            }).toString();

            const apnResponse = await axiosClient.get(`/apn?${queryParams}`);
            const refResponse = await axiosClient.get(`/ref?${queryParams}`);
            const apnData = await apnResponse.data;
            const refData = await refResponse.data;

            const combinedData = [
                ...apnData.map((d: any) => ({
                    x: d.x,
                    y: d.y,
                    source: "apn",
                    filename: d.filename,
                    imageUrl: `https://backend.${window.location.hostname}/data/images/apn/${d.filename}`,
                    // imageUrl: `${BASE_URL}data/images/apn/${d.filename}`
                })),
                ...refData.map((d: any) => ({
                    x: d.x,
                    y: d.y,
                    source: "ref",
                    filename: d.filename,
                    imageUrl: `https://backend.${window.location.hostname}/data/images/${options[0].toLowerCase()}/${d.filename}`,
                    // imageUrl: `${BASE_URL}data/images/${options[0].toLowerCase()}/${d.filename}`,
                })),
            ];

            const dataWithNeighbors = combinedData.map(point => {
                const neighbors = combinedData
                    .filter(d => d.filename !== point.filename)
                    .map(d => ({
                        ...d,
                        _dist: Math.hypot(d.x - point.x, d.y - point.y)
                    }))
                    .sort((a, b) => a._dist - b._dist)
                    .slice(0, 50)
                    .map(({_dist, ...rest}) => rest);

                return {...point, neighbors};
            });

            setApnData(dataWithNeighbors.filter(d => d.source === "apn"));
            setData(dataWithNeighbors);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchData(selectedOptions);
    }, [selectedOptions]);

    const handleSelectionChange = (options: string[]) => {
        setSelectedOptions(options);
    };

    if (!authorized) {
        return <LoginPage onLogin={() => setAuthorized(true)}/>;
    }

    return (
        <div className="App">

            <div className="App-body">
                <div className="App-right">
                    <LeftColumn data={apnData}
                                filterImage={filterImage}
                                setFilterImage={setFilterImage}
                                hideAPNs={hideAPNs}
                                setHideAPNs={setHideAPNs}
                    />
                </div>
                <div className="App-left">
                    <div className="menu-container">
                        <TopMenu onSelectionChange={handleSelectionChange} onDatasetChange={handleDatasetChange}/>
                    </div>
                    <div className="free-space">
                        <CenterPlot data={data}
                                    setSelectedImage={setSelectedImage}
                                    filterImage={filterImage}
                                    hideAPNs={hideAPNs}
                                    fetchError={fetchError}
                        />
                    </div>
                </div>
                <div className="App-right">
                    <RightColumn selectedImage={selectedImage}
                                 images={data}
                                 selectedOptions={selectedOptions}
                                 hideAPNs={hideAPNs}
                                 filterImage={filterImage}
                    />
                </div>
            </div>
        </div>
    )
}

export default App;